import { Box } from '@mui/material';
import React from 'react';
import { theme } from '../../../constants/theme';
import { EsSignupHeader } from '../../Header/EsSignupHeader';
import { ThemeContext } from '../../../module/ThemeManager';
import { useNavigate } from 'react-router-dom';
import { useScrollDetection } from '../../../hook/useScrollDetection';
import { Spotlight } from '../../Spotlight/Spotlight';

export interface IFooterProps {
    children: any;
    noScroll?: boolean;
}

const FooterContainer: React.FC<IFooterProps> = ({ children }) => {
    const navigate = useNavigate();
    const { containerRef } = useScrollDetection();

    return (
        <ThemeContext.Consumer>
            {({ themeStyle }) => {
                return (
                    <Box
                        sx={{
                            width: '100vw',
                            justifyContent: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            marginTop: '10px',
                        }}>
                        <EsSignupHeader
                            label="Go back"
                            arrowColor={theme[themeStyle].primary_orange}
                            onClick={() => navigate(-1)}
                        />
                        <Spotlight position={'50%'} />

                        <Box
                            ref={containerRef}
                            sx={{
                                zIndex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: {
                                    xs: '90vw',
                                    lg: '70vw',
                                    sm: '70vw',
                                },
                                maxWidth: '800px',
                                overflow: 'scroll',
                                p: 4,
                                position: 'relative',
                            }}>
                            {children}
                        </Box>
                    </Box>
                );
            }}
        </ThemeContext.Consumer>
    );
};

export { FooterContainer };
